// base
import React from 'react';

// styles
import { StyledAlertModal } from './style';

export const AlertModal = ({ children, isSingleBtn, ...props }) => {
  return (
    <StyledAlertModal
      centered
      width={300}
      $hasTitle={!!props.title}
      $isSingleBtn={isSingleBtn}
      {...props}
      zIndex={9999999}
    >
      {children}
    </StyledAlertModal>
  );
};
